import {
    themeLightBackgroundShading,
    themeLightPrimary,
    themeLightStateDisabled,
    fontFamily,
    fontSizeText,
    fontLineHeight,
} from '@porsche-design-system/components-react/styles';

const themeTokens = {
    primaryColor: themeLightPrimary,
    hoveredPrimaryColor: themeLightBackgroundShading,

    secondaryColor: '#323639',
    hoveredSecondaryColor: '#151718',

    tertiaryColor: '#323639',
    hoveredTertiaryColor: '#151718',

    disabledColor: themeLightStateDisabled,
    disabledTextColor: '#ffffff8c',

    textColor: 'rgb(1, 2, 5)',

    baseFontSize: fontSizeText.small,
    buttonFontSize: '1rem',
    inputFontSize: '1rem',

    inputFieldHeight: '48px',

    /**
     * Font used from v3 was loaded from cdn,
     * that can lead to different font size with the uploaded one.
     * Use this instead when needed
     */
    fontFamily,
    fontLineHeight,
};

export default themeTokens;
